export interface Config {
  [key: string]: string,
}

const Config = {
  apiBaseUrl: 'https://beta.customily.com/api',
  username: 'frontEndDev',
  password: 'f6NTaW\\Z*P.T2kXn',
  grantType: 'password',
  clientId: 'all',
  imageBaseUrl: 'https://cdn-beta.customily.com'
}

export default Config
